import React, { FC } from 'react'
import ReactMarkdown from 'react-markdown'
import { Content, DefaultPage } from '@shared/layout/DefaultPage'
import { BackArrowHeader } from '@widgets/BackArrowHeader'
import { Heading } from '@ui/Heading'
import { useIonRouter, UseIonRouterResult } from '@ionic/react'

interface MarkDownPageProps {
	text: string
	title?: string
	backPath?: string
}

export const MarkDownPage: FC<MarkDownPageProps> = ({ text, title, backPath }) => {
	const nav: UseIonRouterResult = useIonRouter()

	const goBackFunction = () => {
		if (!backPath) {
			nav.goBack()
			return
		}
		nav.push(backPath, 'back', 'replace')
	}

	return (
		<DefaultPage>
			<Content>
				<BackArrowHeader goBackFunction={goBackFunction}>
					{title && <Heading size={17}>{title}</Heading>}
				</BackArrowHeader>
				<div style={{ marginTop: 10 }}></div>
				<ReactMarkdown
					components={{
						h1: ({ node, ...props }) => (
							<h1
								style={{ fontSize: '2em', fontWeight: 'bold', marginBottom: '1em' }}
								{...props}
							/>
						),
						h2: ({ node, ...props }) => (
							<h2
								style={{
									fontSize: '1.7em',
									fontWeight: 'bold',
									marginBottom: '0.8em',
								}}
								{...props}
							/>
						),
						h3: ({ node, ...props }) => (
							<h3
								style={{
									fontSize: '1.2em',
									fontWeight: 'bold',
									marginBottom: '0.6em',
								}}
								{...props}
							/>
						),
						p: ({ node, ...props }) => (
							<p
								style={{ fontSize: '1em', lineHeight: '1.6', marginBottom: '1em' }}
								{...props}
							/>
						),
						ul: ({ node, ...props }) => (
							<ul
								style={{
									listStyleType: 'disc',
									marginLeft: '1.5em',
									marginBottom: '1em',
								}}
								{...props}
							/>
						),
						li: ({ node, ...props }) => (
							<li style={{ marginBottom: '0.5em' }} {...props} />
						),
						strong: ({ node, ...props }) => (
							<strong style={{ fontWeight: 'bold' }} {...props} />
						),
						a: ({ node, ...props }) => (
							<a style={{ color: 'blue', textDecoration: 'underline' }} {...props} />
						),
					}}>
					{text}
				</ReactMarkdown>
			</Content>
		</DefaultPage>
	)
}
